// extracted by mini-css-extract-plugin
export default {"footer":"footer__kmcya","social_links":"social_links__BGM4t"};